import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function HomePage() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        textAlign: 'center',
        padding: '2rem',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '1rem',
        backdropFilter: 'blur(10px)',
        maxWidth: '600px'
      }}>
        <h1 style={{ fontSize: '3rem', marginBottom: '1rem' }}>
          📚 StudyPal
        </h1>
        <p style={{ fontSize: '1.5rem', marginBottom: '2rem' }}>
          AI 학습 도우미
        </p>
        <p style={{ fontSize: '1rem', opacity: 0.9, marginBottom: '2rem' }}>
          사진 찍으면 자동으로 분석하는 스마트 오답노트
        </p>

        {/* 메인 액션 버튼 */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          marginTop: '2rem'
        }}>
          <button
            onClick={() => navigate('/register')}
            style={{
              padding: '1.5rem',
              background: 'white',
              color: '#667eea',
              border: 'none',
              borderRadius: '0.75rem',
              fontSize: '1.2rem',
              fontWeight: 'bold',
              cursor: 'pointer',
              boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
              transition: 'transform 0.2s'
            }}
            onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
            onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
          >
            📸 오답노트 등록
          </button>

          <button
            onClick={() => navigate('/records')}
            style={{
              padding: '1.5rem',
              background: 'rgba(255, 255, 255, 0.2)',
              color: 'white',
              border: '2px solid white',
              borderRadius: '0.75rem',
              fontSize: '1.2rem',
              fontWeight: 'bold',
              cursor: 'pointer',
              backdropFilter: 'blur(10px)',
              transition: 'transform 0.2s'
            }}
            onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
            onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
          >
            📚 오답노트 보기
          </button>
        </div>

        {/* Phase 1 MVP 상태 */}
        <div style={{
          marginTop: '3rem',
          padding: '1rem',
          background: 'rgba(255, 255, 255, 0.2)',
          borderRadius: '0.5rem'
        }}>
          <p style={{ fontSize: '0.875rem', marginBottom: '0.5rem' }}>
            🚀 Phase 1 MVP
          </p>
          <p style={{ fontSize: '0.75rem', opacity: 0.8 }}>
            ✅ Monorepo 구조 완성<br/>
            ✅ Gemini Vision API 연동<br/>
            ✅ 오답노트 등록/조회<br/>
            🔄 Google OAuth (진행 중)
          </p>
        </div>
      </div>
    </div>
  );
}
